import React, { useContext } from "react";
import { AppContext } from "../../App";
import { col } from "framer-motion/m";
import description from "../../data/description";

export default function Limudim({
  title,
  titleStyle,
  leftSection,
  descriptionStyle,
  imageStyle
}) {
  const { colors } = useContext(AppContext);

  const styles = {
    container: leftSection,
    title: titleStyle,
    description: descriptionStyle,
    image:imageStyle
  };

  const contentData = [
  {
    title: "מסלול ההסדר",
    description:
      "ישיבת מעלות הינה ישיבת הסדר, הדוגלת בשילוב לימוד התורה והשירות הצבאי, מתוך אמונה באיחוד התורה בכל תחומי החיים, לרבות השירות הצבאי, ומתוך אחריות לכלל ישראל.\n\n" +
      "מסלול הלימודים בן חמש השנים מורכב משלושה חלקים: כשנה וחצי של לימודים בישיבה, לאחר מכן שירות צבאי פעיל בן שנה וחמישה חודשים, ולבסוף חזרה ללימודים בישיבה לשנתיים נוספות.\n\n" +
      "בשנתם הראשונה בישיבה שירותם הצבאי של תלמידי הישיבה דחוי. בתחילת השנה השנייה ממשיכים התלמידים ללמוד כחצי שנה נוספת, ולאחר מכן מתגייסים לשירות פעיל. כמעט כל בעלי פרופיל קרבי מתגייסים ליחידות קרביות, על פי שיבוץ איגוד ישיבות ההסדר.\n\n" +
      "בתחילת שיעור ד' חוזרים התלמידים לישיבה, כשחלקם ממשיכים במסלול פיקוד ומשתחררים בסוף השנה החמישית.\n\n" +
      "למעוניינים, ניתן להמשיך ללמוד בישיבה גם לאחר סיום המסלול. כמו כן, ניתן לשלב לימודי תואר בהוראה במסגרת מכון הוראה הפועל בישיבה.",
      image:"/yeshiva-luz.png"
  },
  {
    title: "סדר היום",
    description:
      "עיקר הלימוד בישיבה מבוסס על אחריות אישית, לימוד עצמי ובחברותא, תוך ליווי רבני הישיבה, שיעורים עם ראש הישיבה והר\"מים לאורך השבוע, ודגש על הקניית כלים ללימוד עצמאי.\n\n" +
      "סדר הבוקר מוקדש ללימוד גמרא בעיון ומסתיים בשיעור עיון מהר\"מים. סדר הצהריים פתוח ללימוד מגוון תחומים – גמרא, מוסר, תנ\"ך, מחשבה, אמונה ועוד. במהלך היום מועברים שיעורים בנושאים רבים: מדרש, פרשת שבוע, כוזרי, מהר\"ל, כתבי הרב קוק, מורה נבוכים, חסידות ועוד – חלקם ביוזמת קבוצות תלמידים.\n\n" +
      "סדר ערב מתמקד בלימוד גמרא בבקיאות, בחברותות של תלמידים צעירים ובוגרים, ויוצר קשרים לימודיים וחברתיים. לעיתים מתקיימים שיעורים גם לאחר סדר ערב בבתי הרבנים והאברכים.\n\n" +
      "חלק מהשיעורים מוקלטים ונמצאים באתר הישיבה."
  },
  {
    title: "ליווי אישי",
    description:
      "כל תלמיד מקיים פגישת ליווי שבועית עם אחד מהר\"מים לבחירתו. הקשר האישי מהווה מרכיב משמעותי בליווי התלמיד הן בלימוד והן בבניית אישיותו.\n\n" +
      "תשומת הלב האישית והאמון ההדדי מאפשרים לתלמיד להתקדם ולגדול. הרב המלווה מסייע לתלמיד להכיר את כוחותיו, תכונותיו ומידותיו, ומלווה אותו בבניית דרכו.\n\n" +
      "הקשר הקרוב מאפשר מקום לשיתוף – בשמחות, אתגרים או שגרת היומיום, ויוצר אקלים של הקשבה וצמיחה."
  },
  {
    title: "הכנה לחיים",
    description:
      "הישיבה שמה דגש על עבודת המידות, בניית האישיות, תפיסת עולם והשקפה עמוקה, וקשר עוצמתי לתורה שיימשך גם לאחר תקופת הישיבה.\n\n" +
      "המטרה אינה רק להיות 'ישיבה טובה', אלא מקום שיצמיח אנשים טובים. השקפה זו ניכרת באופי השיעורים, בהקניית כלים ללימוד, ובאווירה שבבית המדרש.\n\n" +
      "ראש הישיבה מקיים שיחות אישיות עם תלמידי שיעורים ד'-ה' בנושאים של השקפה והכוונה לחיים. הרוח בישיבה מזמינה לימוד מתוך בחירה אישית, ומעודדת שאילת שאלות ולימוד כנה ואמיתי – בסדרים, בשיעורים, בליוויים ובמפגשים חברתיים ואמוניים."
  }
];


  return (
    <div style={styles.container}>
      <h2 style={styles.title}>{title}</h2>

      {contentData.map((e, index) => (
        <div key={index}>
          <h3>{e.title}</h3>
          <div style={styles.description}>

            {e.title === 'אחראי שבושי"ם'
              ? e.description.split("\n").map((line, i) => {
                  const [name, phoneRaw] = line.split(" – ");
                  const phone = phoneRaw.replace(/[^0-9]/g, "");
                  const phoneForLink = "972" + phone.replace(/^0/, "");
                  const firstName = name.split(" ")[0];
                  const message = encodeURIComponent(
                    `שלום ${firstName}, אני מעוניין להגיע לשבו"ש לישיבה. דברו איתי בבקשה.`
                  );
                  const link = `https://wa.me/${phoneForLink}?text=${message}`;

                  return (
                    <div
                      key={i}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5em",
                        marginBottom: "0.5em",
                      }}
                    >
                      <img
                        src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
                        alt="וואטסאפ"
                        style={{ width: "20px", height: "20px" }}
                      />
                      <span>
                        {name} –{" "}
                        <a
                          href={link}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {phoneRaw}
                        </a>
                      </span>
                    </div>
                  );
                })
              : e.description
                  .split("\n")
                  .map((line, i) => <div key={i}>{line}</div>)}
          </div>
              { e.image&&<img  src={e.image} style={styles.image}/>}

        </div>
      ))}
    </div>
  );
}
